import { render } from "./buttonBack.vue?vue&type=template&id=466a33c2"
import script from "./buttonBack.vue?vue&type=script&lang=js"
export * from "./buttonBack.vue?vue&type=script&lang=js"

import "./buttonBack.vue?vue&type=style&index=0&id=466a33c2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__